import { ChangeEvent, useEffect, useState } from "react";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, FormSelect, InputGroup } from "react-bootstrap";

export interface CancelableSelectProps {
  placeHolder: string;
  options: { value: string; label: string }[];
  value: string | undefined;
  disabled: boolean;
  onSelect: (item: string | undefined) => void;
}

const CancelableSelect = ({
  placeHolder,
  options,
  value,
  disabled,
  onSelect,
}: CancelableSelectProps) => {
  const [selectedValue, setSelectedValue] = useState(value ?? "");

  useEffect(() => {
    if (value ?? "" !== selectedValue)
      setSelectedValue(value ?? "");    
  }, [value])

  const handleSelect = (e: ChangeEvent<HTMLSelectElement>) => {
    setSelectedValue(e.target.value);
    onSelect(e.target.value);
  };

  const handleCancel = () => {
    setSelectedValue("");
    onSelect(undefined);
  };

  return (
    <InputGroup>
      <FormSelect
        value={selectedValue}
        onChange={handleSelect}
        disabled={disabled}
      >
        <option value="" disabled>
          {placeHolder}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </FormSelect>
      <Button
        variant="primary"
        onClick={handleCancel}
        title="Cancel Selection"
        disabled={value === undefined || disabled}
      >
        <FontAwesomeIcon
          color="white"
          size="lg"
          icon={faTimes}
        ></FontAwesomeIcon>
      </Button>
    </InputGroup>
  );
};

export default CancelableSelect;
